import React from 'react'
import { Grid, Typography, Card, CardContent } from '@mui/material'

const HowToGetPaidScreen = () => {
  return (
    <Grid container justifyContent='center' alignItems='center' className='container' direction='column' spacing={1} style={{ width: '100%', margin: '0' }}>
      <Grid item>
        <Typography variant='h4' style={{ textTransform: 'uppercase' }}>How to get paid</Typography>
      </Grid>

      <Grid item style={{ maxWidth: '60%' }}>
        <Card>
          <CardContent>
            <Grid container alignItems='center' spacing={2}>
              <Grid item><Typography variant='body1'>- Teachers will receive payment from 7-8 days from the finishing time of the lesson.</Typography></Grid>

              <Grid item><Typography variant='body1'>- If there are any complaints from the student about the booked lesson, then the teaching fee of that lesson will be held up for us to check the complaint.
              </Typography></Grid>

              <Grid item><Typography variant='body1'>
                - If there are not any complaints from students, then the lesson is considered already successful.
              </Typography></Grid>

              <Grid item><Typography variant='body1'>- Teaching fee will be sent to teacher's bank account based on banking card's information you provided us.</Typography></Grid>

              <Grid item><Typography variant='body1'>- We will contact both student and teacher after the complaint is checked.</Typography></Grid>

              <Grid item><Typography variant='body1'>- Please feel free to send us a message or call us when you have any question.</Typography></Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid >
  );
}

export default HowToGetPaidScreen
